import { useStore } from 'Stores/index'

import type { userRolesEnum } from 'Constants/userRoles'

import { limitedRolesPermissionsConfig } from 'Portal/src/config/permissions.config'
import type {
  GlobalPermissions,
  LimitedRolePermissionsConfig,
} from 'Portal/src/types/permissions.types'

export type UserPermissions = Omit<
  LimitedRolePermissionsConfig,
  keyof GlobalPermissions
> & {
  isLimitedUser: boolean
  global: GlobalPermissions
}

/**
 * Custom hook to check user permissions for modules and global actions based on their roles.
 */
export function usePermissions(): UserPermissions {
  const { userStore } = useStore()
  const {
    user: { roles },
  } = userStore

  const limitedRole = roles.find(role =>
    Object.keys(limitedRolesPermissionsConfig).includes(role),
  ) as userRolesEnum

  if (!limitedRolesPermissionsConfig[limitedRole]) {
    return {
      allowedPaths: [],
      global: {},
      isLimitedUser: false,
      modules: {},
    }
  }

  const { allowedPaths, modules, ...globalPermissions } =
    limitedRolesPermissionsConfig[limitedRole]

  return {
    allowedPaths,
    global: globalPermissions,
    isLimitedUser: true,
    modules,
  }
}
